// Header.tsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu as MuiMenu, MenuItem } from '@mui/material';
import logo from '../assets/athena-logo-white.png';
import '../styles/Header.css';
import { Menu as MenuIcon, X } from 'lucide-react';

const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
      if (window.innerWidth >= 640) setAnchorEl(null);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className='header'>
      <div className='header-inner'>
        {/* Logo (image only, no text) */}
        <Link to='/' className='logo'>
          <img src={logo} alt='Athena' />
        </Link>

        {/* Desktop buttons */}
        {!isMobile && (
          <nav className='actions'>
            <Link to='/athena/migrate-account' className='btn'>
              Migrate Account
            </Link>
            <Link to='/request-account' className='btn'>
              Request Account
            </Link>
          </nav>
        )}
      </div>

      {isMobile && (
        <div className='menu-container relative'>
          <button
            id='mobile-menu-button'
            aria-controls={menuOpen ? 'mobile-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={menuOpen ? 'true' : undefined}
            onClick={handleMenuOpen}
            className='hamburger-btn'
          >
            {menuOpen ? <X size={24} /> : <MenuIcon size={24} />}
          </button>

          <MuiMenu
            id='mobile-menu'
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleMenuClose}
          >
            <MenuItem
              component={Link}
              to='/athena/migrate-account'
              onClick={handleMenuClose}
            >
              Migrate Account
            </MenuItem>
            <MenuItem
              component={Link}
              to='/request-account'
              onClick={handleMenuClose}
            >
              Request Account
            </MenuItem>
          </MuiMenu>
        </div>
      )}
    </header>
  );
};

export default Header;
